export default {
	CAMP: 'camp',
	GAME: 'game',
	LOGIN: 'login',
	NOT_SUPPORTED: 'not_supported',
	PREVIEW: 'preview',
	SETTINGS: 'settings',
	SETUP: 'setup',
	SPLASH: 'splash',
	TEACHER_GAME: 'teacher_game',
	TEACHER_WINNERS: 'teacher_winners',
	WINNERS: 'winners',
}
